import type { HTMLAttributes } from 'react';

import SupportTicketLink from './SupportTicketLink';

export default function ErrorWithSupport({
  as: Tag = 'p',
  children,
  ...props
}: HTMLAttributes<HTMLElement> & { as?: 'p' | 'div' | 'span' }) {
  return (
    <Tag role="alert" {...props}>
      {children}
      <span className="mt-2 block">
        <SupportTicketLink />
      </span>
    </Tag>
  );
}
